<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <!--div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group  margin-0">
          <label class="col-sm-2 control-label">
            Type
          </label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="type" clearable  >
                  <el-option 
                  v-for="item in typeObj"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <el-button type="primary" @click="search">{{
                $t("message.Search")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div-->
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-sm-12">
                <div class="dfb">
                  <div>
                    <p>Notice:</p>
                    <p>
                      1. For pushed status notification, NO Edit or Delete
                      action is allowed;
                    </p>
                    <p>
                      2. Notification Time : The info will display after the msg
                      pushed .
                    </p>
                  </div>
                  <div>
                    <el-button
                      @click="gotoDetail"
                      v-if="checkPermission('PUSH_LIST_ADD')"
                      >{{ $t("message.Add") }}</el-button
                    >
                    <el-button
                      @click="showWarning"
                      v-if="checkPermission('PUSH_LIST_DEL')"
                      >{{ $t("message.Delete") }}</el-button
                    >
                  </div>
                </div>
              </div>

              <div class="col-xs-12">
                {{ total }}{{ $t("message.datagridresult") }}
              </div>
              <el-table
                :data="rows"
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                row-key="id"
                :cell-class-name="cell"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  prop="content"
                  :show-overflow-tooltip="true"
                  label="Push content"
                  min-width="200"
                ></el-table-column>
                <el-table-column
                  prop="notificationDate"
                  label="Notification time"
                  width="170"
                >
                </el-table-column>
                <el-table-column
                  prop="pushStatusName"
                  label="Push status"
                  width="110"
                >
                <template slot-scope="scope">
                  <div :style="scope.row.pushStatus==2?'color:red;':''">{{ scope.row.pushStatusName }}</div>
                </template>
                </el-table-column>
                <el-table-column
                  prop="createdAt"
                  label="Created time"
                  width="170"
                >
                </el-table-column>
                <el-table-column label="Action" width="70" fixed="right">
                  <template slot-scope="scope">
                    <el-row>
                      <el-col :span="24"
                        ><el-button
                          size="mini"
                          @click="handleDbClick(scope.row)"
                          icon="el-icon-edit"
                        ></el-button
                      ></el-col>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config";
import Sortable from "sortablejs";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      page: 1, //当前页数
      pagesize: 10, //一页显示几条
      filter: "",
      name: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "DESC",
      sortField: "id",
      status: "",
      statusObj: [],
      typeObj: [],
      type: "",
      status: "",
      startDate: "",
      endDate: "",
      period: null,
      canDrag: true,
    };
  },
  created: function () {},
  methods: {
    async init() {
      this.canDrag = true;
      var objdata = this.getAuthObj();

      objdata.page = {
        pageIndex: this.page,
        pageCount: this.pagesize,
      };
      objdata.sort = {
        name: this.sortField,
        type: this.sortType,
      };
      objdata.type = this.type;
      objdata.status = this.status;
      objdata.apiUrl = this.apiConfig.pushNotificationList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rows = data.data.result.notifications;
      this.setObj();
      this.total = data.data.result.total;
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.page = 1;
      this.init();
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    cell: function ({ row }) {
      // if (!this.canDrag) {
      //   return "disabled pointer";
      // }
      // if (row.status == 1) {
      //   return "cursor-move";
      // } else {
      //   return "disabled pointer";
      // }
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/notificationDetail",
        query: {
          id: row.id,
        },
      });
    },
    gotoDetail() {
      this.$router.push({ path: "/main/notificationDetail" });
    },
    async deleteList() {
      let objdata = this.getAuthObj();
      objdata.ids = [];
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          objdata.ids.push(this.multipleSelection[i].id);
        }
      }

      objdata.apiUrl = this.apiConfig.pushNotificationDelete;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    },
    setObj: function () {
      this.statusObj = [
        {
          value: "1",
          label: this.$i18n.t("message.Active"),
        },
        {
          value: "0",
          label: this.$i18n.t("message.Inactive"),
        },
      ];
      this.typeObj = [
        {
          value: 0,
          label: "Broadcast message",
        },
        {
          value: 1,
          label: "Promotion",
        },
      ];
      let list = null;
      for (list of this.rows) {
        var category = [];
        list.category.forEach(function (item) {
          category.push(item.name);
        });
        list.categoryName = category.join(", ");
        list.createdAt = this.dateFormat(list.createdAt);
        list.notificationDate = this.dateFormat(list.notificationDate);
        if (list.status === 0) {
          list.statusName = this.$i18n.t("message.Inactive");
        } else if (list.status == 1) {
          list.statusName = this.$i18n.t("message.Active");
        }

        if (list.type === 0) {
          list.typeName = "Broadcast message";
        } else if (list.type == 1) {
          list.typeName = "Promotion";
        }
        if (list.pushStatus === 0) {
          list.pushStatusName = "Pending";
        } else if (list.pushStatus == 1) {
          list.pushStatusName = "Pushed";
        }
        else if (list.pushStatus == 2) {
          list.pushStatusName = "Submitted";
        }
        else if (list.pushStatus == 3) {
          list.pushStatusName = "Reject";
        }
        
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
